import React, { useState } from "react"
import {
  MainContainer,
  Download,
  Heading,
  FormContainer,
  InputFlex,
  CustomInput,
  InputContainer,
  Label,
  CustomSelect,
  Astrick,
  ArrowContainer,
  DropdownContainer,
  Item,
  Textarea,
  Text,
  SubmitButton,
} from "./submitstyles"
import { BiCloudDownload } from "react-icons/bi"
import file from "../../files/samplepdf.pdf"
import { CgAsterisk } from "react-icons/cg"
import { IoIosArrowDown } from "react-icons/io"

const AbstractForm = () => {
  const fields = {
    title: "",
    name: "",
    email: "",
    alternateEmail: "",
    phone: "",
    whatsappNumber: "",
    city: "",
    organization: "",
    country: "",
    interestedIn: "",
    abstractTitle: "",
    message: "",
    file: "",
  }
  const titles = ["Dr.", "Mr.", "Miss.", "Mrs."]
  const interests = ["Speaker", "Student", "Poster", "Virtual", "Sponsor"]
  const country_list = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antigua &amp; Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia &amp; Herzegovina",
    "Botswana",
    "Brazil",
    "British Virgin Islands",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Cape Verde",
    "Cayman Islands",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "Cote D Ivoire",
    "Croatia",
    "Cruise Ship",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Polynesia",
    "French West Indies",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kuwait",
    "Kyrgyz Republic",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macau",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Namibia",
    "Nepal",
    "Netherlands",
    "Netherlands Antilles",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Norway",
    "Oman",
    "Pakistan",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Reunion",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Pierre &amp; Miquelon",
    "Samoa",
    "San Marino",
    "Satellite",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "South Africa",
    "South Korea",
    "Spain",
    "Sri Lanka",
    "St Kitts &amp; Nevis",
    "St Lucia",
    "St Vincent",
    "St. Lucia",
    "Sudan",
    "Suriname",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor L'Este",
    "Togo",
    "Tonga",
    "Trinidad &amp; Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks &amp; Caicos",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "Uruguay",
    "Uzbekistan",
    "Venezuela",
    "Vietnam",
    "Virgin Islands (US)",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ]
  const [dropdown, Setdropdown] = useState(null)
  const [myfields, setfields] = useState(fields)
  const handleChange = e => {
    const { name, value } = e.target
    setfields({ ...myfields, [name]: value })
  }

  return (
    <div style={{ background: "#000" }}>
      <MainContainer>
        <Heading>Submit Abstract</Heading>
      </MainContainer>
      <FormContainer>
        <Download href={file} download className="hvr-shrink">
          Download Sample Abstract File
          <BiCloudDownload
            color="#fff"
            size="30px"
            style={{ marginLeft: "5px" }}
          />
        </Download>
        <form>
          <InputFlex>
            <InputContainer>
              <Label htmlFor="title">
                Title{" "}
                <Astrick>
                  <CgAsterisk />
                </Astrick>
                :
              </Label>
              <CustomSelect
                open={dropdown === "title" ? true : false}
                onClick={() =>
                  dropdown !== "title"
                    ? Setdropdown("title")
                    : Setdropdown(null)
                }
              >
                {myfields.title}
                <ArrowContainer
                  style={{
                    transform: dropdown === "title" ? "rotateZ(-180deg)" : "",
                  }}
                >
                  <IoIosArrowDown size="25px" />
                </ArrowContainer>
              </CustomSelect>
              {dropdown === "title" && (
                <DropdownContainer>
                  {titles.map(node => (
                    <Item
                      onClick={() => {
                        Setdropdown(null)
                        setfields({ ...myfields, title: node })
                      }}
                    >
                      {" "}
                      {node}
                    </Item>
                  ))}
                </DropdownContainer>
              )}
            </InputContainer>

            <InputContainer>
              <Label htmlFor="name">Name:</Label>
              <CustomInput
                name="name"
                value={myfields.name}
                onChange={handleChange}
              ></CustomInput>
            </InputContainer>
          </InputFlex>
          <InputFlex>
            <InputContainer>
              <Label htmlFor="email">Email:</Label>
              <CustomInput
                name="email"
                type="email"
                value={myfields.email}
                onChange={handleChange}
              ></CustomInput>
            </InputContainer>
            <InputContainer>
              <Label htmlFor="alternateEmail">Alternate Email:</Label>
              <CustomInput
                name="alternateEmail"
                type="email"
                value={myfields.alternateEmail}
                onChange={handleChange}
              ></CustomInput>
            </InputContainer>
          </InputFlex>
          <InputFlex>
            <InputContainer>
              <Label htmlFor="phone">Phone:</Label>
              <CustomInput
                name="phone"
                type="number"
                value={myfields.phone}
                onChange={handleChange}
              ></CustomInput>
            </InputContainer>
            <InputContainer>
              <Label htmlFor="whatsappNumber">Whatsapp Number:</Label>
              <CustomInput
                name="whatsappNumber"
                type="number"
                value={myfields.whatsappNumber}
                onChange={handleChange}
              ></CustomInput>
            </InputContainer>
          </InputFlex>
          <InputFlex>
            <InputContainer>
              <Label htmlFor="city">City:</Label>
              <CustomInput
                name="city"
                type="text"
                value={myfields.city}
                onChange={handleChange}
              ></CustomInput>
            </InputContainer>
            <InputContainer>
              <Label htmlFor="organization">Organization:</Label>
              <CustomInput
                name="organization"
                type="text"
                value={myfields.organization}
                onChange={handleChange}
              ></CustomInput>
            </InputContainer>
          </InputFlex>
          <InputFlex>
            <InputContainer>
              <Label>
                Select Country{" "}
                <Astrick>
                  <CgAsterisk />
                </Astrick>
                :
              </Label>
              <CustomSelect
                open={dropdown === "country" ? true : false}
                onClick={() =>
                  dropdown !== "country"
                    ? Setdropdown("country")
                    : Setdropdown(null)
                }
              >
                {myfields.country}
                <ArrowContainer
                  style={{
                    transform: dropdown === "country" ? "rotateZ(-180deg)" : "",
                  }}
                >
                  <IoIosArrowDown size="25px" />
                </ArrowContainer>
              </CustomSelect>
              {dropdown === "country" && (
                <DropdownContainer
                  style={{ height: "300px", overflowX: "hidden" }}
                >
                  {country_list.map(node => (
                    <Item
                      onClick={() => {
                        Setdropdown(null)
                        setfields({ ...myfields, country: node })
                      }}
                    >
                      {" "}
                      {node}
                    </Item>
                  ))}
                </DropdownContainer>
              )}
            </InputContainer>
            <InputContainer>
              <Label>
                Interested In{" "}
                <Astrick>
                  <CgAsterisk />
                </Astrick>
                :
              </Label>
              <CustomSelect
                style={{ zIndex: dropdown === "interested" ? "2" : "0" }}
                open={dropdown === "interested" ? true : false}
                onClick={() =>
                  dropdown !== "interested"
                    ? Setdropdown("interested")
                    : Setdropdown(null)
                }
              >
                {myfields.interestedIn}
                <ArrowContainer
                  style={{
                    transform:
                      dropdown === "interested" ? "rotateZ(-180deg)" : "",
                  }}
                >
                  <IoIosArrowDown size="25px" />
                </ArrowContainer>
              </CustomSelect>
              {dropdown === "interested" && (
                <DropdownContainer>
                  {interests.map(node => (
                    <Item
                      onClick={() => {
                        Setdropdown(null)
                        setfields({ ...myfields, interestedIn: node })
                      }}
                    >
                      {" "}
                      {node}
                    </Item>
                  ))}
                </DropdownContainer>
              )}
            </InputContainer>
          </InputFlex>
          <InputFlex>
            <InputContainer style={{ width: "100%" }}>
              <Label htmlFor="abstractTitle">Abstract Title:</Label>
              <CustomInput
                name="abstractTitle"
                type="text"
                value={myfields.abstractTitle}
                onChange={handleChange}
              ></CustomInput>
            </InputContainer>
          </InputFlex>
          <InputFlex>
            <InputContainer style={{ width: "100%" }}>
              <Label htmlFor="message">Message:</Label>
              <Textarea
                style={{ height: "100px", borderRadius: "10px" }}
                name="message"
                type="text"
                value={myfields.message}
                onChange={handleChange}
              ></Textarea>
            </InputContainer>
          </InputFlex>
          <InputFlex style={{ marginTop: "42px" }}>
            <InputContainer style={{ width: "100%" }}>
              <Label htmlFor="file">Upload Your Abstract File:</Label>
              <CustomInput
                style={{
                  height: "50px",
                  borderRadius: "10px",
                  paddingTop: "8px",
                }}
                name="file"
                type="file"
                accept=".doc,.docx,.pdf"
                value={myfields.file}
                onChange={handleChange}
              ></CustomInput>
            </InputContainer>
          </InputFlex>
          <Text>Select PDF or DOC,DOCX File</Text>
          <SubmitButton type="submit" className="hvr-shrink">
            Submit Abstract
          </SubmitButton>
        </form>
      </FormContainer>
    </div>
  )
}
export default AbstractForm
